// extracted by mini-css-extract-plugin
export var active = "_ge-2";
export var recordingDot = "_ge-1";
export var recordingIndicator = "_ge-0";